var React = require('react');

function Hamby0 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44836","data-name":"Group 44836","transform":"translate(15411 -1557)"},React.createElement("g",{"id":"menu-r","transform":"translate(-15412 1556)"},[React.createElement("path",{"id":"Path_104360","data-name":"Path 104360","d":"M2.25,6.25h19.5v1.5H2.25Z","fill":"currentColor","key":0}),React.createElement("path",{"id":"Path_104361","data-name":"Path 104361","d":"M2.25,11.25h19.5v1.5H2.25Z","fill":"currentColor","key":1}),React.createElement("path",{"id":"Path_104362","data-name":"Path 104362","d":"M21.75,16.25H2.25v1.5h19.5Z","fill":"currentColor","key":2})])));
}

Hamby0.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Hamby0;

Hamby0.default = Hamby0;
